import * as R from 'ramda';
import React, { lazy, Suspense } from 'react';
// components
import { FormGroupTitlePanel } from '../../../../components/form-group-table';
// forms
import { FormGroupWrapper } from '../../../../forms';
// helpers/constants
import * as G from '../../../../helpers';
// ui
import { MainActionButton } from '../../../../ui';
//
import EquipmentServiceDocuments from './documents';
import { withEquipmentServiceActions } from '../hocs/with-equipment-service-actions';
//////////////////////////////////////////////////

const FleetList = lazy(() => import('../../../fleet-list'));

const tableSettings = {
  minHeight: 320,
  cellFontSize: 12,
  titleFontSize: 12,
  titleRowHeight: 50,
  allowEditBtn: true,
  tableRowHeight: 35,
  useMainColors: true,
  allowSelectAll: false,
  checkBoxCellWidth: 27,
  expandableItems: true,
  searchableTitles: true,
  allowSelectItems: false,
  maxHeight: 'calc(100vh - 90px)',
  tableWrapperProps: { ml: '2px' },
  expandedDetailsComponent: ({ parentProps, callbackData } = {}) => (
    <EquipmentServiceDocuments
      primaryObjectGuid={G.getGuidFromObject(parentProps)}
      disabled={R.pathOr(false, ['disabled'], parentProps)}
      documentList={R.pathOr([], ['details'], parentProps)}
      {...R.pick(
        [
          'openModal',
          'entityType',
          'closeModal',
          'openLoader',
          'closeLoader',
          'isReadOnlyMode',
          'documentTypeOptions',
        ],
        R.or(callbackData, {}),
      )}
    />
  ),
};

const CreateButton = ({ openMaintenanceForm }) => (
  <MainActionButton
    mx={10}
    mb='3px'
    height={30}
    width={165}
    onClick={() => openMaintenanceForm()}
  >
    {G.getWindowLocale('actions:add-equipment-service', 'Add Equipment Service')}
  </MainActionButton>
);

const EquipmentServiceReport = (props) => {
  const {
    isOpened,
    isReadOnlyMode,
    handleChangeStatus,
    openMaintenanceForm,
    handleToggleFormGroup,
    handleCreateRelatedTask,
    handleRemoveEquipmentService,
  } = props;

  const renderAdditionalComponent = () => {
    if (isReadOnlyMode) return null;

    return <CreateButton openMaintenanceForm={openMaintenanceForm} />;
  };

  return (
    <FormGroupWrapper isOpened={isOpened}>
      <FormGroupTitlePanel
        isOpened={isOpened}
        isHiddenAddIcon={true}
        handleToggleFormGroup={handleToggleFormGroup}
        panelTitle={G.getWindowLocale('titles:fleet-equipment-service', 'Fleet Equipment Service')}
      />
      <Suspense fallback={null}>
        <FleetList
          pt='0px'
          pb='6px'
          withoutPageActions={true}
          usePortalForFilters={true}
          useSavedReportState={false}
          openedFromFleetProfile={true}
          tableSettings={tableSettings}
          isReadOnlyMode={isReadOnlyMode}
          handleChangeStatus={handleChangeStatus}
          openMaintenanceForm={openMaintenanceForm}
          additionalComponent={renderAdditionalComponent()}
          handleCreateRelatedTask={handleCreateRelatedTask}
          handleUpdateEquipmentService={openMaintenanceForm}
          handleRemoveEquipmentService={handleRemoveEquipmentService}
          callbackData={R.assoc('withoutExpandedContainer', true, props)}
        />
      </Suspense>
    </FormGroupWrapper>
  );
};

export default withEquipmentServiceActions(EquipmentServiceReport);
